import { render, staticRenderFns } from "./ContainersList.vue?vue&type=template&id=67c084a3&scoped=true&lang=pug"
import script from "./ContainersList.vue?vue&type=script&lang=ts"
export * from "./ContainersList.vue?vue&type=script&lang=ts"
import style0 from "./ContainersList.vue?vue&type=style&index=0&id=67c084a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c084a3",
  null
  
)

export default component.exports